import { FC } from "react";
import { Wrapper, HeaderText, ListItem, ListIcon, Text, Helper, StyledList } from './elements';
import { scheduleFinalInterview, moveToJobOffer, summary, taggedComment, endDate, response, applicantApplied, commented } from '../../../assets/icons'
import moment from "moment";

type Props = {
  isLoading?: boolean;
  notifications: any;
  onClickNotification: (notification: any) => void;
  onChange?: (pagination: any, filters: any) => void;
  user: any;
  currentPage?: number | undefined;
  total?: number;
  pageSize?: number;
};

const Notification: FC<Props> = ({ notifications, isLoading, onClickNotification, currentPage, user, onChange, total, pageSize }) => {
  const isInterviewer = (interviewee: string, interviewersList: any) => {
    return !!interviewersList.find((i: any) => i.name === interviewee);
  }

  return (
    <Wrapper>
      <HeaderText>Notifications</HeaderText>
      <StyledList pagination={{
        onChange: onChange,
        pageSize: pageSize,
        current: currentPage,
        total: total,
        showSizeChanger: true,
      }} dataSource={notifications} loading={isLoading} renderItem={(notification: any) => (
            <ListItem key={notification.id} onClick={() => onClickNotification(notification)} isRead={notification.read}>
              <ListIcon src={
                notification.type === 'commented' && user && notification.description.includes(user.name) ?
                  taggedComment :
                  notification.type === 'move' ?
                    moveToJobOffer :
                    notification.type === 'schedule' ?
                      scheduleFinalInterview :
                      notification.type === 'commented' ?
                        commented :
                        notification.type === 'applied' ?
                          applicantApplied :
                          notification.type === 'end' ?
                            endDate :
                            notification.type === 'response' ?
                              response :
                              summary
              } />
              <Text>{notification.type === 'commented' && user && notification.description.includes(user.name) ?
                `${notification.user.name} tagged you in a comment`
                : notification.type === 'schedule' && notification?.interviewers?.length && isInterviewer(user.name, notification.interviewers) && (user.isAdmin || user.isSuperAdmin) ? 
                notification.interviewerDescription
                : notification.title
              }</Text>
              <Helper>{moment(notification.createdAt.toDate()).format("MM/DD/YYYY hh:mm a")}</Helper>
            </ListItem>
           )}>
      </StyledList>
    </Wrapper>
  )
}

export default Notification;